import { CircleCheck, UsersIcon } from 'lucide-react'

import { Checkbox } from 'slab'
import { type MemberOnboardingProvider } from 'utils/web_api.schemas'

export const InNetworkProviderCard: React.FC<{
  providers?: MemberOnboardingProvider[];
  inNetworkProviders?: MemberOnboardingProvider[];
  selectedProviderNpis?: number[];
  onProviderToggle: (provider: MemberOnboardingProvider, isSelected: boolean) => void;
}> = ({ providers = [], inNetworkProviders = [], selectedProviderNpis = [], onProviderToggle }) => {
  return (
    <div className='border rounded-lg border-gray-400 bg-white overflow-hidden'>
      <div className='flex flex-col p-4'>
        <div className='flex gap-1 mb-1'>
          <UsersIcon size={14} />
          <span className='body-bold'>Providers</span>
        </div>
        <span className='body-sm text-gray-500 mb-3'>We can check up to 5 providers for you</span>
        <div data-testid='providers' className='flex flex-col gap-2'>
          {
            providers.map((provider) => {
              if (inNetworkProviders.find(p => p.npi === provider.npi)) return null
              const name = [provider.first_name, provider.last_name].join(' ')
              return (
                <div className='p-3 border rounded-lg' key={provider.npi}>
                  <Checkbox
                    onChange={e => onProviderToggle(provider, e.target.checked)}
                    label={name}
                    defaultChecked={selectedProviderNpis.includes(provider.npi)}
                  />
                </div>
              )
            })
          }
        </div>
      </div>
      {
        inNetworkProviders.length > 0 && (
          <div data-testid='in-network' className='p-4 bg-gray-50 border-t border-gray-200 flex flex-col'>
            <div className='body-sm text-gray-500'>These providers are in-network with all of your selected plans:</div>
            {
              inNetworkProviders.map((provider) => {
                const name = [provider.first_name, provider.last_name].join(' ')
                return (
                  <div className='flex gap-1' key={provider.npi}>
                    <CircleCheck size={16} />
                    <span className='body-sm'>{name}</span>
                  </div>
                )
              })
            }
          </div>
        )
      }
    </div>
  )
}
